import Breadcrumb from "../components/layout/breadcrumb";

export default function Contatti(){
    return (
        <>
            <Breadcrumb location="Contatti" />

            <div class="ltn__contact-address-area mb-90">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                                <div class="ltn__contact-address-icon">
                                    <img src="img/icons/10.png" alt="Icon Image"/>
                                </div>
                                <h3>Indirizzo Email</h3>
                                <p>info@webmail.com <br/>
                                    jobs@webexample.com</p>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                                <div class="ltn__contact-address-icon">
                                    <img src="img/icons/11.png" alt="Icon Image"/>
                                </div>
                                <h3>Telefono</h3>
                                <p> 0984 24454 <br/> 366 1907 155</p>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                                <div class="ltn__contact-address-icon">
                                    <img src="img/icons/12.png" alt="Icon Image"/>
                                </div>
                                <h3>Sede</h3>
                                <p>Piazza Giacomo Mancini 18,<br/>87100 Cosenza (CS)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
  

            <div class="ltn__contact-message-area mb-120 mb--100">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="ltn__form-box contact-form-box box-shadow white-bg">
                                <h4 class="title-2">Contattaci</h4>
                                <form id="contact-form" action="mail.php" method="post">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="input-item input-item-name ltn__custom-icon">
                                                <input type="text" name="name" placeholder="Denominazione"/>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-6">
                                            <div class="input-item input-item-phone ltn__custom-icon">
                                                <input type="text" name="phone" placeholder="Numero di telefono"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-item input-item-textarea ltn__custom-icon">
                                        <textarea name="message" placeholder="Contenuto del messaggio"></textarea>
                                    </div>
                                    <p><label class="input-info-save mb-0"><input type="checkbox" name="agree"/> Informativa Privacy</label></p>
                                    <div class="btn-wrapper mt-0">
                                        <button class="btn theme-btn-1 btn-effect-1 text-uppercase" type="submit">Invia</button>
                                    </div>
                                    <p class="form-messege mb-0 mt-20"></p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
  
            <div class="google-map mb-120">
            
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3087.684046268331!2d16.253833815643183!3d39.29541533098884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133f90cc68ef2df7%3A0x9504813acf53ecb9!2sPiazza%20Giacomo%20Mancini%2C%2018%2C%2087100%20Cosenza%20CS!5e0!3m2!1sit!2sit!4v1672683957765!5m2!1sit!2sit" width="100%" height="100%" frameborder="0" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                
            </div>
         

        </>
    );
    
}